/**
 * Coup de pouce, Attendu 1252 « calculer le pourcentage d'une quantité »
 * (3e, Proportionnalité). Seconde passe 3e (2026-09-13). TROIS pages « un
 * cas par page » partagées par les trois clés, le MÊME dessin : la barre
 * de 240 coupée en dix paquets de 10 % (24 chacun), suite de la fiche
 * 1056 (5e : 1 %, 10 %, 50 % d'un nombre) et de la grille de 100.
 *   « 30 % : des paquets de 10 % » : 10 % de 240 = 24, 3 paquets = 72.
 *   « 25 % : la moitié de la moitié » : 50 % = 120, 25 % = 60.
 *   « 5 % : la moitié de 10 % » : 10 % = 24, 5 % = 12 ; 15 % = 24 + 12 = 36.
 * Le pourcentage n'est jamais la réponse (30 % de 240, ce n'est pas 30),
 * c'est l'erreur principale (DEPP 4e 2023 q.16).
 *
 * SACRIFIÉ : N = 240 pour tous les pourcentages (gen_1252,
 * gen1252.self.test.js) ; 300 importé de 1056.
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';
const BLEU_CLAIR = '#DBEAFE';
const ORANGE_CLAIR = '#FED7AA';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const gras = (t, couleur = ENCRE) => `<tspan font-weight="bold" fill="${couleur}">${t}</tspan>`;

const X0 = 40; const W = 32; const Y = 50;
/** La barre de 240 en dix paquets de 24 ; `pleins` paquets orange, plus éventuellement un demi-paquet. */
const barre = (pleins, demi = false) => {
    const out = [];
    for (let k = 0; k < 10; k++) {
        const x = X0 + k * W;
        const plein = k < pleins;
        out.push(`<rect x="${x}" y="${Y}" width="${W}" height="28" fill="${plein ? ORANGE_CLAIR : BLEU_CLAIR}" stroke="${BLEU}" stroke-width="1.2"/>`);
        if (demi && k === pleins) out.push(`<rect x="${x + 0.6}" y="${Y + 0.6}" width="${W / 2 - 0.6}" height="26.8" fill="${ORANGE_CLAIR}" stroke="none"/>`);
        out.push(`<text x="${x + W / 2}" y="${Y + 19}" font-size="11" font-weight="bold" text-anchor="middle" fill="${plein ? ORANGE : BLEU}">24</text>`);
    }
    out.push(`<text x="${X0}" y="${Y - 8}" font-size="11" text-anchor="start" fill="${GRIS}">240 en dix paquets de 10 % : un paquet = 24</text>`);
    out.push(`<path d="M ${X0} ${Y + 34} L ${X0} ${Y + 42} L ${X0 + 10 * W} ${Y + 42} L ${X0 + 10 * W} ${Y + 34}" fill="none" stroke="${GRIS}" stroke-width="1.2"/>`);
    out.push(`<text x="200" y="${Y + 56}" font-size="12" text-anchor="middle" fill="${GRIS}">100 % = 240</text>`);
    return out.join('\n  ');
};

const SVG_30 = svg(
    'Une barre de 240 coupée en dix paquets de 10 %, un paquet vaut 24. Trois paquets sont en orange : 30 % de 240, c’est 3 fois 24 égale 72. 30 % de 240, ce n’est pas 30.',
    `${barre(3)}
  ${ligne(150, `10 % de 240 = 240 ÷ 10 = ${gras('24')}`, 14)}
  ${ligne(176, `30 %, c’est 3 paquets de 10 % : 3 × 24 = ${gras('72', ORANGE)}`, 14)}
  ${ligne(208, '30 % de 240, ce n’est pas 30 : je compte les paquets.', 12, GRIS)}`,
    224,
);

const SVG_25 = svg(
    'La même barre de 240 en dix paquets de 24. Deux paquets et demi sont en orange : 25 %. La moitié de 240, c’est 120 ; la moitié de 120, c’est 60. 25 % de 240 égale 60.',
    `${barre(2, true)}
  ${ligne(150, `50 % de 240, c’est la moitié : ${gras('120')}`, 14)}
  ${ligne(176, `25 %, c’est la moitié de 50 % : 120 ÷ 2 = ${gras('60', ORANGE)}`, 14)}
  ${ligne(208, '25 % = un quart : deux paquets et demi de 10 %.', 12, GRIS)}`,
    224,
);

const SVG_5 = svg(
    'La même barre de 240 en dix paquets de 24. Un demi-paquet est en orange : 5 %, la moitié de 10 %. 10 % de 240 égale 24, donc 5 % égale 12. Et 15 %, c’est 10 % plus 5 % : 24 plus 12 égale 36.',
    `${barre(0, true)}
  ${ligne(150, `10 % de 240 = ${gras('24')} ; 5 %, c’est la moitié : ${gras('12', ORANGE)}`, 14)}
  ${ligne(176, `15 % = 10 % + 5 % : 24 + 12 = ${gras('36')}`, 14)}
  ${ligne(208, 'J’assemble des paquets de 10 % et des moitiés.', 12, GRIS)}`,
    224,
);

const AIDE = {
    pages: [
        { titre: '30 % : des paquets de 10 %', svg: SVG_30 },
        { titre: '25 % : la moitié de la moitié', svg: SVG_25 },
        { titre: '5 % : la moitié de 10 %', svg: SVG_5 },
    ],
};

const CP_1252 = {
    flash_texte_trou_saisie: AIDE,
    pct_qcm_unique: AIDE,
    pct_tableau_vf: AIDE,
};

export default CP_1252;
